import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

const GraphView = ({ graphData }) => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );

    const options = {
        indexAxis: 'x',
        elements: {
            bar: {
                borderWidth: 50, // Set border width to 50px
            },
        },
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: {
                display: false, // Places legend on the right
            },
            title: {
                display: true,
                text: 'Quantity per Area', // Title of the chart
            },
        },
    };

    console.log(graphData);

    const labels = Object.keys(graphData);

    const data = {
        labels,
        datasets: [
            {
                label: 'Quantity',
                data: Object.values(graphData),
                backgroundColor: [
                    '#7AECA8',
                    '#E0AF6E',
                    '#5A97D4',
                ],
                borderColor: 'transparent',
                borderWidth: 50,
            },
        ],
    };

    return (
        <div style={{
            width: '100%',           
            height: 'calc(100vh - 50px)',
            maxWidth: '1200px',      
            boxSizing: 'border-box', 
            padding: '20px',         
        }}>
            <Bar options={options} data={data} />
        </div>
    );
};

export default GraphView;
